<script>
import { notify } from '@/helpers/notify' 
import { mapState } from 'vuex';
import Ability from '@/helpers/mixins/ability'

export default {
    name: 'CreatePaymentModal',
    props:[
        "data",
    ],
    mixins: [Ability],
    data() {
        return {
            form: {},
            paymnet_type:0,
            banks:[],
            installments: {
                installments:[]
            },
            odenecek_tutar: 0,
            disableds: [],
            secili: [],
            odenen_taksitler: [],
            submitted: false,
            checked:[]
        };
    }, 
    computed:{
        modalTitle(){ 
            return this.userDetail.paymnet_type == 1 ?  
            "Nakit Ödeme" : this.userDetail.paymnet_type == 2 ? 
            "Kredi Kartı İle Ödeme" : this.userDetail.paymnet_type == 3 ? 
            "Çek İle Ödeme" : this.userDetail.paymnet_type == 4 ?   
            "Havale İle Ödeme" : this.userDetail.paymnet_type == 5 ?  "Veresiye İle Ödeme"  : "Ödeme Al" 
        },
         ...mapState('userDetail', ['userDetail']), 
         ...mapState('dataMove', ['dataMove']),
    },
    watch:{
        secili(val){
            this.odenen_taksitler = val.map(e=> e.num)
            if(this.form.paymnet_type != 5){
                this.form.amount = val.reduce((partialSum, a) => parseFloat(partialSum) + parseFloat(a.price), 0);
            }else{
                this.form.amount = 0;
            }
        },
        userDetail:{
            handler(newVal){  
                this.odenen_taksitler = []
                this.form = { amount: 0, explaine: '' }
                this.secili = []
                const { id, paymnet_type, component } = newVal
                this.odenecek_tutar = 0;
                let odenecek_tutar = 0
                this.$http.get(`members/${id}/getInstallments`)
                    .then((response) => {
                        this.installments = response.data
                        response.data.installments.map(e=>{
                            if(e.num > (response.data.totalcount - response.data.remaining)){
                                odenecek_tutar += parseFloat(e.price)
                            }
                        })
                        this.odenecek_tutar = odenecek_tutar
                    });

                this.form = Object.assign( {...this.form} ,{ id, paymnet_type, component })
                this.getBanks(this.userDetail.paymnet_type)
            },
            deep:true
        }, 
    },
    methods: {
        handleSubmit(){
            this.submitted = true;
            const { id } = this.form 
            this.$http.post(`members/${id}/balances/store`, { ...this.form, odenen_taksitler: this.odenen_taksitler })
                        .then((resp) => notify.success(resp.data.message))
        },
         getBanks(paymnet_type){
            let type= 0;

            if( paymnet_type == 2)
            type = 'banka'
            else if( paymnet_type == 3)
            type = 'cek'
            else if( paymnet_type == 4)
            type = 'havale'

            this.$http.post(`safebank`,{ output:'only', type} )
                        .then((response) => this.banks = response.data)
        },
        
        close(){
            this.$parent.$bvModal.hide('create_payment_modal')
        },
        paymnetChannel(e){
            this.$store.dispatch('userDetail/setUserDetailOne', { paymnet_channel :e.target.value });
        },
       
        dsbled(i){
            return this.checked.includes(i);
        },

        createPayment( { target }){ 
            this.getBanks(target.value)
        },  
    },
};
</script>

<template>
<b-modal id="create_payment_modal"  :title="modalTitle"  no-close-on-backdrop hide-footer>
    <form @submit.prevent="handleSubmit">
        <div class="row" v-if="installments && installments.remaining > 0">
            <div class="col-md-12">
                <div class="alert alert-warning">
                    Taksit sırasıyla ödenecek taksiti işaretleyiniz.
                </div>
            </div>
            <div class="col-md-12">
                <table class="table table-bordered table-hover table-sm">
                    <thead class="thead-light">
                        <tr>
                            <th colspan="3">Kalan Taksitler Tablosu</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(installment,i) in installments.installments" :key="i">
                            <th style="width:10px">
                                <input 
                                    v-if="installment.num >(installments.totalcount - installments.remaining)" 
                                    :id="`checkbox${installment.num}`"
                                    type="checkbox" 
                                    v-model="secili" 
                                    :value="installment" 
                                    :disabled="dsbled(i)"
                                    /> 
                            </th>
                            <th class="text-end ml-3">{{ installment.num }} . Taksit</th>
                            <th class="text-start ml-3" style="width:50%">
                                <span v-if="installment.num <= (installments.totalcount - installments.remaining)" style="text-decoration:line-through">
                                    {{ installment.price }} TL
                                    <span class="badge rounded-pill bg-warning ms-1">Ödendi</span>
                                </span>
                                <span v-else>{{ installment.price }} TL </span> 
                            </th>
                        </tr>
                    </tbody>
                    <tfoot> 
                        <tr style="background:#d7d7d7">
                            <th></th>
                            <th class="text-end ml-3">Toplam Kalan Taksit Tutarı</th>
                            <th class="text-start ml-3">{{ odenecek_tutar }} TL</th>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>
        <div class="row d-flex flex-wrap mb-1" v-if="form.component == 'onodeme' && !ability('dealer')">
            <label class="col-sm-5 col-form-label col-form-label" for="tur">Ödeme Türü</label>
            <div class="col">
                <select 
                    class="form-select" 
                    v-model="form.paymnet_type"
                    @change="createPayment($event)"

                    >
                        <option value="">Seçiniz</option>
                        <option value="5">Veresiye</option>
                        <option value="1">Nakit</option>
                        <option value="2">Kredi Kartı</option>
                        <option value="4">Havale</option>
                        <option value="3">Çek</option>
                </select>
            </div>
        </div> 
        <div class="row d-flex flex-wrap mb-1" v-if="!ability('dealer') && form.paymnet_type != 5">
            <label class="col-sm-5 col-form-label col-form-label" for="amount">Ödenen Ücret</label>
            <div class="col">
                <input
                    id="amount" 
                    v-model="form.amount"
                    type="text"
                    class="form-control"
                />
          </div>
        </div>
        <div class="row d-flex flex-wrap mb-1" v-if="form.paymnet_type == 2 || form.paymnet_type == 3 || form.paymnet_type == 4">
            <label class="col-sm-5 col-form-label col-form-label" for="bank"  v-if="form.paymnet_type == 2">POS Bankası</label>
            <label class="col-sm-5 col-form-label col-form-label" for="bank"  v-else-if="form.paymnet_type == 4">Havale Bankası</label>
            <label class="col-sm-5 col-form-label col-form-label" for="bank"  v-else>Çek Bankası</label>
            <div class="col">
            <select class="form-select" v-model="form.credit_card_bank" id="bank">
                <option :value="bank.id" v-for="bank in banks" :key="bank.id">{{ bank.title }} </option>
            </select>
          </div>
        </div>
        <div class="row d-flex flex-wrap mb-1"  v-if="form.paymnet_type == 3">
            <label class="col-sm-5 col-form-label col-form-label" for="cheque_giver_name">Çek Sahibi</label>
            <div class="col">
                <input
                id="cheque_giver_name" 
                v-model="form.cheque_giver_name"
                type="text"
                class="form-control"
                />
          </div>
        </div>
        <div class="row d-flex flex-wrap mb-1" v-if="form.paymnet_type == 3">
            <label class="col-sm-5 col-form-label col-form-label" for="cheque_number">Çek Numarası</label>
            <div class="col">
                <input
                id="cheque_number" 
                v-model="form.cheque_number"
                type="text"
                class="form-control"
                />
          </div>
        </div>
        <div class="row d-flex flex-wrap mb-1"  v-if="form.paymnet_type == 3">
            <label class="col-sm-5 col-form-label col-form-label" for="cheque_date">Çek Tarihi</label>
            <div class="col">
                <input
                id="cheque_date" 
                v-model="form.cheque_date"
                type="date"
                class="form-control"
                />
          </div>
        </div>
        <!--<div class="row d-flex flex-wrap mb-1" v-if="form.paymnet_type != 5">
            <label class="col-sm-5 col-form-label col-form-label" for="invoice_num">Makbuz No</label>
            <div class="col">
                <input
                id="invoice_num" 
                v-model="form.invoice_num"
                type="text"
                class="form-control"
                />
          </div>
        </div>-->
         <div class="row d-flex flex-wrap mb-1" v-if="!ability('dealer')">
            <label class="col-sm-5 col-form-label col-form-label" for="explaine">Açıklama</label>
            <div class="col">
                <input
                id="explaine" 
                v-model="form.explaine"
                type="text"
                class="form-control"
                />
          </div>
        </div>
        <div class="d-flex justify-content-between mt-3">
            <b-button variant="light" @click="close()">Vazgeç</b-button>
            <b-button 
                type="submit" 
                variant="success" 
                class="ms-1"
                >Öde
            </b-button>
        </div>
    </form>
</b-modal>
</template>